import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import translate from '../../../../../../commonComponents/translate';

function InboxContainer(props) {
  const {
    t,
    children,
    style,
    image,
    title,
    createdAt,
    link = t('inbox_readMore'),
    onClick,
  } = props;

  const hasAction = !!onClick;
  const hasFooter = hasAction || createdAt;

  const Image =
    typeof image === 'string' ? <img src={image} alt="message" /> : image;

  return (
    <div className="news-item" style={style}>
      {Image && (
        <div className="news-item-image">
          <Image />
        </div>
      )}
      <div className="news-item-content">
        <div className="news-item-title">{title}</div>
        <div className="news-item-description">{children}</div>
        {hasFooter && (
          <div className="news-item-footer">
            {hasAction ? (
              <button
                type="button"
                className="news-item-footer-link"
                onClick={onClick}
              >
                {link}
              </button>
            ) : (
              <div />
            )}
            <div className="news-item-footer-date">
              {moment.utc(createdAt).format('DD MMM, YYYY')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

InboxContainer.propTypes = {
  t: PropTypes.func.isRequired,
  createdAt: PropTypes.number,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  link: PropTypes.string,
  style: PropTypes.shape({}),
};

InboxContainer.defaultProps = {
  createdAt: null,
  image: null,
  style: undefined,
  onClick: null,
  link: undefined,
};

export default translate(InboxContainer);
